declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../models/api_response_model';
import { ApiRequestModel } from '../../../models/api_request_model';
import { SpinnerService } from '../../../services/spinner.service';
import { AppData } from '../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DOCService } from '../../../services/doc.service';
import { DownloadFileRequest } from '../../../models/docs/doc.model';
import {
  ActorIdentitiesRequest, ActorDocRequest, ActorDocController,
  SaveCounsellingPlanRequest, PatientInfoByFormattedCodeController,
  PatientInfoByFormattedCodeRequest, X_BillHeaderController,
  X_BillItemsController, X_BillReceiptsController, x_BillDetailsRequest,
  BillDetailsInfoController,

  MisReportCategoriesRequest,
  MisReportCategoriesController,
  MisReportDefByCategoryRequest,
  MisReportDefByCategoryController,
  SaveActorReportSetting,
  GenericProcPostRequest,
  S_Methods
} from '../../../models/actor/actor';
import { ActorService } from '../../../services/actor.service';
import { DBOperation } from '../../../enums/enum';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../shared/services/toastr.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'customize-dashboard',
  templateUrl: './customizedashboard.modal.html',
  styleUrls: ['./customizedashboard.modal.scss']
})

export class NgbCustomizeDashboardModal implements OnInit {
  ngOnInit(): void {
    this.LoadMisCategories();
    this.pdata = null;
 
  } public ApiResData: ApiResponseModel;

  public isRequesting: boolean = false;
  constructor(
    public activeModal: NgbActiveModal,
    private loaderService: SpinnerService,
    private tosterservice: NGXToastrService,
    private modalService: NgbModal,
 
    private actorservice: ActorService
    ) { }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  CurrentMisReportCategoriesController: MisReportCategoriesController[];
  CurrentMisReportCategoriesRequest: MisReportCategoriesRequest;
        
  LoadMisCategories() {
    this.CurrentMisReportCategoriesRequest = new MisReportCategoriesRequest();
    this.CurrentMisReportCategoriesRequest.ConditionalOperator = 10;
    this.CurrentMisReportCategoriesRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetMisReportCategoriesController();
  }
  GetMisReportCategoriesController() {
    this.StartRefreshing();


    //alert(this.FormattedCode);
    this.actorservice.GetMisReportCategoriesController(this.CurrentMisReportCategoriesRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentMisReportCategoriesController = this.ApiResData.Result;
          //this.pdata = this.CurrentFollicularScansBetweenDateController;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.LoadOvaryData();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  SelectedModule: MisReportCategoriesController;
  ViewModuleWidgets(obj: any) {
    this.SelectedModule  = obj;
    if (this.SelectedModule != null) {
      this.ReportCategory = this.SelectedModule.ReportCategory;
      this.LoadReportsByCategory();
      //this.SelectedModuleDetails = null;
      //this.SelectedModuleDetails = Module;
      //this.ShowList = true;
      //this.ShowList2 = true;
      //this.CurrentAccessRightsByRoleController = null;
      //this.LoadAccessRights(this.SelectedModuleDetails.ModuleID);

    }

  }

  public ReportCategory: string;
  pdata : MisReportDefByCategoryController[];
  CurrentMisReportDefByCategoryController: MisReportDefByCategoryController[];
  CurrentMisReportDefByCategoryRequest: MisReportDefByCategoryRequest;
  LoadReportsByCategory() {
    this.CurrentMisReportDefByCategoryRequest = new MisReportDefByCategoryRequest();

    this.CurrentMisReportDefByCategoryRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetMisReportDefByCategoryController();
  }
  GetMisReportDefByCategoryController() {
    this.StartRefreshing();
    this.CurrentMisReportDefByCategoryRequest.ReportCategory = this.ReportCategory;
    this.CurrentMisReportDefByCategoryController = null;
    //alert(this.FormattedCode);
    this.actorservice.GetMisReportDefByCategoryController(this.CurrentMisReportDefByCategoryRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentMisReportDefByCategoryController = this.ApiResData.Result;
          this.pdata = this.CurrentMisReportDefByCategoryController;
          // this.CanLoadReport = false;
          //this.pdata = this.CurrentFollicularScansBetweenDateController;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.LoadOvaryData();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  GetRecordStatus(l: MisReportDefByCategoryController): boolean {
    return l.RecordStatus == 'D' ? false : true;
  }
  onSubmit(l: MisReportDefByCategoryController, e) {
    var saveReq = new SaveActorReportSetting();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 20042;
    saveReq.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.FeatureCode = l.ReportDefCode;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //saveReq.

    if (e.target.checked) {
      saveReq.AccessLevel = true;  
    }
    else if (!e.target.checked) {
      saveReq.AccessLevel = false;    
    }
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 20042;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)    
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            //this.spinner.hide();
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );


  }
}
